import { isEmpty } from "lodash";
import { TOASTIFY_STATUS } from "../constants/application";
import { GENERIC_ERROR_MESSAGE } from "../constants/common";
import { notifyToaster } from "../helpers/common";

const BASE_URL =
  "https://s3.amazonaws.com/assets.caradvise.com/segment_events/segment-events-combined.json";

export const fetchSegmentEvents = async () => {
  try {
    const response = await fetch(BASE_URL);
    const segments = await response.json();

    if (isEmpty(segments)) {
      notifyToaster(response.error || GENERIC_ERROR_MESSAGE, {
        type: TOASTIFY_STATUS.error,
      });
      throw new Error(response.error);
    }

    return segments;
  } catch (error) {
    throw new Error(error.message);
  }
};
